import { i18n } from '@/locales';
const lc = 'views.user_management.';
export const userStatusTypeCode = [
    'ALL',
    'Y', // 정상
    'S', // 정지
    'E', // 종료
];
const imgIconCodeList = {
    ALL: '',
    Y: 'ok',
    S: 'stop',
    E: 'leave',
};
export default userStatusTypeCode.map((code) => ({
    text: i18n.t(`${lc}${code === 'ALL'
        ? 'all'
        : imgIconCodeList[code]}`),
    value: code,
    field: 'useYn',
    imgIcon: imgIconCodeList[code],
}));
